import React from "react";
import './Header.css'

const Header = () => {
  return (
    <header className="header-container">
      <div className="logo-header-container">
        <img className="logo-container" src="./assets/logos/logo-bj.png" alt="" />
      </div>
    </header>
  );
};

export default Header;
